import React, { useState, useEffect, useRef } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import menuData from "../data/menuData"; // menuData 가져오기
import axios from "axios";
import { FaUserCircle } from "react-icons/fa"; // 아이콘 추가
import "./navbar.css";

function NavigationBar() {
  const [activeDropdown, setActiveDropdown] = useState(null); // 활성화된 드롭다운
  const [clickedDropdown, setClickedDropdown] = useState(null); // 클릭한 드롭다운
  const [logoWidth, setLogoWidth] = useState("200px"); // 로고 너비 상태
  const [user, setUser] = useState(null);
  const dropdownRef = useRef(null); // 드롭다운 참조
  const [isLoaded, setIsLoaded] = useState(false); // 로딩 상태 추가
  const [error, setError] = useState(null);

  const handleMouseEnter = (index) => {
    if (clickedDropdown === null) {
      setActiveDropdown(index);
    }
  };

  const handleMouseLeave = () => {
    if (clickedDropdown === null) {
      setActiveDropdown(null);
    }
  };

  const handleDropdownClick = (index) => {
    setClickedDropdown((prev) => (prev === index ? null : index));
    setActiveDropdown((prev) => (prev === index ? null : index));
  };

  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setClickedDropdown(null);
      setActiveDropdown(null);
    }
  };

  // 뷰포트 크기에 따라 로고 크기 변경
  useEffect(() => {
    const updateLogoSize = () => {
      if (window.innerWidth <= 576) {
        setLogoWidth("150px"); // 모바일
      } else if (window.innerWidth <= 768) {
        setLogoWidth("170px"); // 태블릿
      } else {
        setLogoWidth("200px"); // 데스크탑
      }
    };

    window.addEventListener("resize", updateLogoSize);
    updateLogoSize(); // 초기 로드 시 실행
    return () => window.removeEventListener("resize", updateLogoSize);
  }, []);

  // 외부 클릭 감지
  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  // 세션 스토리지에서 사용자 정보 로드
  useEffect(() => {
    const userData = sessionStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    }
    setIsLoaded(true); // 로드 완료
  }, []);

  const handleLogout = () => {
    // 로그아웃 처리: 세션 스토리지와 상태 초기화
    sessionStorage.removeItem("user");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <Navbar bg="white" expand="lg">
      <Container>
        <Navbar.Brand href="/">
          <img
            src="/images/logo/logo.png" // 로고 이미지 경로
            alt="Logo"
            style={{
              maxWidth: logoWidth, // 동적으로 설정된 너비
              height: "auto", // 비율 유지
            }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto" ref={dropdownRef}>
            {menuData.map((menu, index) => (
              <NavDropdown
                key={index}
                title={<span>{menu.title}</span>}
                id={`nav-dropdown-${index}`}
                show={activeDropdown === index || clickedDropdown === index}
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
                onClick={() => handleDropdownClick(index)}
              >
                {menu.items.map((item, idx) => (
                  <NavDropdown.Item key={idx} href={item.path}>
                    {item.label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            ))}
          </Nav>

          <Nav className="ms-auto">
            {isLoaded ? (
              user ? (
                user.nameKor ? (
                  <>
                    <Nav.Link href="/my-page">
                      {user.nameKor}
                      {"님 "}
                      <FaUserCircle style={{ marginLeft: "5px" }} />
                    </Nav.Link>
                    <Nav.Link onClick={handleLogout}>로그아웃</Nav.Link>
                    {user.userType === "ADMIN" && (
                      <Nav.Link href="/admin">관리자 페이지</Nav.Link>
                    )}
                  </>
                ) : (
                  <>
                    <Nav.Link href="/login">로그인</Nav.Link>
                    <Nav.Link href="/register">회원가입</Nav.Link>
                  </>
                )
              ) : (
                <>
                  <Nav.Link href="/login">로그인</Nav.Link>
                  <Nav.Link href="/register">회원가입</Nav.Link>
                </>
              )
            ) : (
              <Nav.Link>로딩 중...</Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavigationBar;
